module.exports = __webpack_public_path__ + "img/icon-circle-comiru.ce8c8cc.png";